import {
	Component,
	ElementRef,
	HostListener,
	Inject,
	Input,
	OnChanges,
	OnInit,
	PLATFORM_ID,
	SimpleChanges,
	ViewChild
} from '@angular/core';
import {FilterControls} from "../interface/filter-controls";
import {FilterData} from "../interface/filter-data";
import {FilterProductPreview} from "../interface/filter-product-preview";
import {arrayDeepCopy, isEmptyString, valueExists} from "bmx-pastebox";
import {FilterService} from "../service/filter.service";
import {FilterTransmissionService} from "../../raintree/transmission/filter-transmission.service";
import {RequestMapperService} from "../../request-mapper.service";
import {FilterUrlModifierService} from "../service/filter-url-modifier.service";
import {FilterUrlDecoderService} from "../service/filter-url-decoder.service";
import {isPlatformBrowser} from "@angular/common";
import {FilterCsvMetadataService} from "../service/filter-csv-metadata.service";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {FilterRelatedProducts} from "../interface/filter-related-products";
import {FabricFilterProductRelatedPreview} from "../interface/fabric-filter-product-related-preview";
import {SeoService} from "../../seo/seo.service";
import {FabricFilters} from "../model/fabric-filters";
import {FinishFilters} from "../model/finish-filters";
import {FilterSEO} from "../interface/filter-seo";
import {SeoData, TwitterCardType} from "@bloomscorp/ngbase";
import {FilterSortService} from "../service/filter-sort.service";
import {FilterControlOption} from "../interface/filter-control-option";
import {AddStructuredDataService} from "../../add-structured-data.service";
import {StoryProductFilter} from "../../stories/interface/story-product-filter";

@UntilDestroy()
@Component({
	selector: 'fb-filter-body',
	templateUrl: './filter-body.component.html',
	styleUrls: ['./filter-body.component.scss']
})
export class FilterBodyComponent implements OnInit, OnChanges {

	@Input()
	public data: FilterData = {} as FilterData;

	@Input()
	public storyId: number = 0;

	public isLoading: boolean = true;
	public isBrowser: boolean = false;
	public productPreviews: FilterProductPreview[] = [];
	public filterResult: FilterProductPreview[] = [];
	public controls: FilterControls = {} as FilterControls;
	public pagedProducts: FilterProductPreview[] = [];
	public filterRelatedProducts: FilterRelatedProducts[] = [];
	public pagedProductRelatedPreviews: FabricFilterProductRelatedPreview[] = [];
	public pageLength: number = 31;
	public pageNumber: number = 1;
	public pageNumberURL: number = 1;
	public pageStartIndex: number = 0;
	public pageEndIndex: number = this.pageNumber * this.pageLength - 1;
	public skeletonFilters: number[] = Array.from({length: 10}, (_, i) => i + 1);
	public showClearFilterButton: boolean = false;
	public isSidebarOpen: boolean = false;
	public activeFilters: FilterControlOption[] = [];
	public selectedParams: {code: 'CAT' | 'SEG'| 'SUB', name: string }[] = [];
	public selectedSortOption: string = 'availability';

	constructor(
		private _filterService: FilterService,
		private _filterSortService: FilterSortService,
		private _filterUrlModifier: FilterUrlModifierService,
		private _filterUrlDecoder: FilterUrlDecoderService,
		private _api: FilterTransmissionService,
		private _metadataApi: FilterCsvMetadataService,
		private _activatedRoute: ActivatedRoute,
		private _seo: SeoService,
		private _structuredData: AddStructuredDataService,
		private _router: Router,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	@ViewChild('loadIntoView', { static: false })
	private loadIntoView: ElementRef<HTMLDivElement> =
		{} as ElementRef<HTMLDivElement>;

	ngOnInit(): void {
		this._fetchMetadataListAndProducts();
		this._activatedRoute.queryParams
			.pipe(untilDestroyed(this))
			.subscribe((params: Params): void => {
				this.selectedParams = [];
				this.showClearFilterButton = Object.keys(params).length !== 0;
				if (Object.keys(params).length > 0)
				{
					Object.entries(params).forEach((param) => {
						if(param[0] === 'page' ) {
							this.pageNumberURL = +param[1];
						}
						else if(param[0] === 'sort-by') {
							this.selectedSortOption = param[1];
						}
						else {
							this._selectSEOParam(param);
						}
					})
				}
				console.log(this.data.group)
				if(this.data.group && this.data.group !== 'story-product') {
					if (this.selectedParams.length > 0) {
						if (this.selectedParams[1].name.split(',').length === 1) {
							this._fetchFilterSEO(this.selectedParams[1].code, this.selectedParams[1].name.replace(/-/g, ' '));
						} else {
							this._fetchFilterSEO(this.selectedParams[0].code, this.selectedParams[0].name.replace(/-/g, ' '));
						}
					} else {
						let seoData: FilterSEO = {
							name: this.data.group === 'finished-product' ? 'Finished' : 'Fabric',
							metaTitle: this.data.group === 'finished-product' ? 'Finished Goods | Anuprerna Artisans | Discover Sustainable Handwoven Finish Products' : 'Fabric | Anuprerna Artisans | Discover Sustainable Handwoven Fabrics',
							metaDescription: 'Discover the artistry at Anuprerna Artisans! Embrace sustainable handwoven fabrics, collaboratively crafted with 300+ skilled Bengal handloom weavers. Explore our range of sustainable fabrics—Cotton, Khadi, Linen, and indigenous Silks like Tussar, Mulberry, Ketya, Eri (Peace Silk). Indulge in cozy scarves, elegant stoles, and timeless garments, each meticulously handspun and handwoven for your unique style.',
							socialImage: this.data.group === 'finished-product' ? 'https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/74HQM48QDE4DI5KD7QKP1IEJ72OC00466.jpg' : 'https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/WGTS2ZKP6137A50ADUUA4VULJUGL09393.png',
							iconImage: ''
						}
						this.initSEO(seoData);
					}
				}
		});
	}

	ngOnChanges(changes: SimpleChanges) {

		const previousFilterData: FilterData = changes['data'].previousValue;
		const currentFilterData: FilterData = changes['data'].currentValue;

		if (
			(valueExists(previousFilterData) &&
			(previousFilterData.name !== currentFilterData.name))
		) {

			this._fetchMetadataListAndProducts();
		}
	}

	private _getConsumedFabric(product: FilterProductPreview): number {
		if(product.size_profile_option_list && product.size_profile_option_list.length > 0) {
			return product.size_profile_option_list[0].size_profile_option_consumed_fabric;
		}
		else if(product.made_to_order_profile_consumed_fabric) {
			return product.made_to_order_profile_consumed_fabric;
		}

		return 1;
	}

	private _calculateProductPrice(product: FilterProductPreview): void {
		product.calculatedPrice = 0;
		if (product.product_group === 'finished') {
			let selectedMadeToOrderFabricPrice: number = product.made_to_order_fabric_price ? product.made_to_order_fabric_price : product.price;
			let consumedFabric: number = this._getConsumedFabric(product);
			let fabricPrice: number = selectedMadeToOrderFabricPrice * consumedFabric;
			product.calculatedPrice = product.price + fabricPrice;
		} else {
			product.calculatedPrice = product.price;
		}
	}

	private _selectSEOParam(param: Params): void {
		let filterKeys: string[] = [];
		if(this.data.group === 'fabric-product') {
			filterKeys = FabricFilters.getKeys();
		}
		else if(this.data.group === 'finished-product') {
			filterKeys = FinishFilters.getKeys();
		}
		if(!filterKeys.includes(param[0])) {
			this.selectedParams[0] = {
				code: 'SEG',
				name: decodeURIComponent(param[0])
			};

			this.selectedParams[1] = {
				code: 'SUB',
				name: decodeURIComponent(param[1])
			};

		}
		if(param[0] === 'category') {
			this.selectedParams[1] = {
				code: 'CAT',
				name: decodeURIComponent(param[1])
			};
		}
	}

	private _fetchFilterSEO(code: 'SUB' | 'SEG' | 'CAT', name: string): void {
		this._api.resolveSEOData(
			code,
			name,
			() => {},
			() => {},
			(response) => {
				if(!response.metaTitle) {
					response.metaTitle =  (response.name ? response.name +  ' | ' : '') + (this.data.group === 'finished-product' ? 'Finished Goods | Anuprerna Artisans | Discover Sustainable Handwoven Finish Products' : 'Fabric | Anuprerna Artisans | Discover Sustainable Handwoven Fabrics');
					response.metaDescription = 'Discover the artistry at Anuprerna Artisans! Embrace sustainable handwoven fabrics, collaboratively crafted with 300+ skilled Bengal handloom weavers. Explore our range of sustainable fabrics—Cotton, Khadi, Linen, and indigenous Silks like Tussar, Mulberry, Ketya, Eri (Peace Silk). Indulge in cozy scarves, elegant stoles, and timeless garments, each meticulously handspun and handwoven for your unique style.'
					response.socialImage = this.data.group === 'finished-product' ? 'https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/74HQM48QDE4DI5KD7QKP1IEJ72OC00466.jpg': 'https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/WGTS2ZKP6137A50ADUUA4VULJUGL09393.png';
				}
				this.initSEO(response);
			},
			() => {},
			() => {}
		)
	}

	private _fetchMetadataListAndProducts(): void {

		this._metadataApi.getColorList(
			() => {
				this.isLoading = true;
			},
			() => {
			}
		);
		this._metadataApi.getMaterialList(
			() => {
				this.isLoading = true;
			},
			() => {
			}
		);

		this._metadataApi.getPatternList(
			() => {
				this.isLoading = true;
			},
			() => {
				this._resolveProductPreviewList();
			}
		);
	}

	private _mapRelatedProducts(pageProducts: FilterProductPreview[]): void {
		pageProducts.forEach(product => {
			const relatedProducts:FilterRelatedProducts | undefined = this.filterRelatedProducts.find(relatedProduct => relatedProduct.id === product.product_id);
			if(!(this.pagedProductRelatedPreviews.find(related => related.product.id === product.id))) {
				this.pagedProductRelatedPreviews.push({
					product: product,
					relatedProducts: relatedProducts? relatedProducts.products: []
				})
			}

		});
		this.isLoading = false;
	}

	private _resolveProductPreviewList(): void {
		if (!isEmptyString(this.data.group)) {
			if (this.data.group === 'story-product' && this.storyId) {
				this._api.getStoryFilterResult(
					this.storyId,
					() => {
						this.isLoading = true;
					},
					(response) => {},
					(response: StoryProductFilter) => {
						this.productPreviews = [
							...response.fabricProductList,
							...response.finishedProductList
						];
						this.productPreviews.forEach(product => this._calculateProductPrice(product));
						this.filterResult = arrayDeepCopy(this.productPreviews);
						this._prepareControls();
						this._filterUrlDecoder.decode(this.controls);
						this.initialiseFilterChanges();
					},
					(error) => {},
					() => {}
				)
			}
			else {
				this._api.getFilterResult(
					this.data.group === 'fabric-product' ? RequestMapperService.GET_FILTER_FABRIC : RequestMapperService.GET_FILTER_FINISHED,
					() => {
						this.isLoading = true;
					},
					(response: FilterProductPreview[]) => {
					},
					(response: FilterProductPreview[]) => {
						this.productPreviews = response;
						this.productPreviews.forEach(product => this._calculateProductPrice(product));
						this.filterResult = arrayDeepCopy(this.productPreviews);
						this._prepareControls();
						this._filterUrlDecoder.decode(this.controls);
						this.initialiseFilterChanges();
					},
					(error: string) => {
						// TODO: show error notification and log error
					},
					() => {
					}
				);
			}
		}
	}

	private _resolveRelatedProductPreviewList(pageProducts: FilterProductPreview[]): void {
		const productIds: string = pageProducts.map(product => product.product_id).join();

		if(productIds) {
			this._api.getFabricRelatedResult(
				productIds,
				() => {
				},
				() => {
				},
				(response: FilterRelatedProducts[]) => {
					this.filterRelatedProducts = response;
					this._mapRelatedProducts(pageProducts);
				},
				() => {
					this._mapRelatedProducts(pageProducts);
				},
				() => {

				},
			)
		}
		else {
			this._mapRelatedProducts(pageProducts);
		}
	}

	private _prepareControls(): void {
		this.controls = this._filterService.prepareFilterControls(
			this.data.controls,
			this.productPreviews
		);
	}

	public initSEO(filterSEO: FilterSEO): void {

		const seoData: SeoData = {
			title: filterSEO.metaTitle,
			tags: {
				description: {
					charset: 'utf-8',
					name: 'description',
					content: filterSEO.metaDescription
				}
			},
			facebook: {
				title: filterSEO.metaTitle,
				type: 'website',
				description: filterSEO.metaDescription,
				image: {
					url: filterSEO.socialImage,
					type: 'image/jpeg',
					width: '600',
					height: '600',
					alt: filterSEO.metaDescription
				},
				url: `https://anuprerna.com${this._router.url}`
			},
			twitter: {
				title: filterSEO.metaTitle,
				description: filterSEO.metaDescription,
				cardType: TwitterCardType.SUMMARY_LARGE,
				image: {
					url: filterSEO.socialImage,
					alt: filterSEO.metaDescription
				}
			}
		};


		this._seo.set(seoData);
	}

	public initialiseFilterChanges(): void {
		this.filterResult = this._filterService.prepareResult(
			this.productPreviews,
			this.controls
		);
		this.activeFilters = this._filterService.selectedFilterControls;
		this.sortProducts(this.selectedSortOption);

		if(!this.storyId && this.data.group !== 'story-product')
			this._filterUrlModifier.modify(this.controls);
	}

	public seekFilterChanges(): void {
		this.isLoading = true;
		this.pageNumberURL = 1;
		this.initialiseFilterChanges();
	}

	public sortProducts(type: string): void {
		this.isLoading = true;
		switch (type) {
			case "availability":
				this.filterResult = this._filterSortService.sortByAvailability(this.filterResult);
				this.selectedSortOption = 'availability';
				break;
			case "new-arrival":
				this.filterResult = this._filterSortService.sortByDate(this.filterResult);
				this.selectedSortOption = 'new-arrival';
				break;
			case "low-to-high":
				this.filterResult = this._filterSortService.sortByLowPrice(this.filterResult);
				this.selectedSortOption = 'low-to-high';
				break;
			case "high-to-low":
				this.filterResult = this._filterSortService.sortByHighPrice(this.filterResult);
				this.selectedSortOption = 'high-to-low';
				break;
			default:
				this.filterResult = this._filterSortService.sortByAvailability(this.filterResult);
				this.selectedSortOption = 'availability';
				break;
		}
		this.initializePage(this.pageNumberURL);
	}

	public initializePage(page: number): void {
		this.pageNumber = page;
		this.pageStartIndex = (this.pageNumber - 1) * this.pageLength;
		this.pageEndIndex = ((this.pageNumber - 1) * this.pageLength) + this.pageLength -1;
		this.pagedProducts = [];
		this.pagedProductRelatedPreviews = [];
		this.loadIntoPage();
	}

	public loadIntoPage(): void {
		if(!this.storyId && this.data.group !== 'story-product') {
			setTimeout(() => {
				this._router.navigate(
					[],
					{
						relativeTo: this._activatedRoute,
						queryParams: {page: this.pageNumber, 'sort-by': this.selectedSortOption},
						queryParamsHandling: 'merge'
					}
				).then(() => {
				});
			}, 0);
		}


		let pageProducts: FilterProductPreview[] = [];
		if((this.filterResult.length > this.pageLength)) {
			if(this.pagedProducts.length < this.pageEndIndex) {
				pageProducts = this.filterResult.slice(this.pageStartIndex, this.pageEndIndex);
				this.pagedProducts.push(...pageProducts);
			}
		}
		else {
			pageProducts = this.filterResult;
			this.pagedProducts = this.filterResult;
		}
		if(this.data.group !== 'story-product')
		this._structuredData.mapToCarouselStructure(this.pagedProducts, this.data.group === 'fabric-product'? 'fabric': 'finished');

		this._resolveRelatedProductPreviewList(pageProducts);
	}

	public clearAllFilterOption(): void {
		this._filterService.clearAllFilter(this.controls);
		this.seekFilterChanges();
	}

	public changePage(page: number): void {
		this.isLoading = true;
		this.pageNumber = page;
		this.pageNumberURL = page;
		this.pageStartIndex = (this.pageNumber - 1) * this.pageLength;
		this.pageEndIndex = ((this.pageNumber - 1) * this.pageLength) + this.pageLength -1;
		this.pagedProducts = [];
		this.pagedProductRelatedPreviews = [];
		this.loadIntoPage();
	}
}
